import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export const EmailCaptureCTA = () => (
  <section className="relative py-28 bg-gradient-to-br from-mahogany-800 to-mahogany-950 overflow-hidden grain" data-testid="email-capture-cta">
    <div className="absolute inset-0 opacity-20" style={{ background: "radial-gradient(circle at 30% 40%, rgba(255,20,147,0.25), transparent 55%)" }} />
    <Reveal className="relative max-w-3xl mx-auto text-center px-6">
      <h2 className="font-serif text-4xl sm:text-6xl font-light text-cream mb-2 tracking-tight">ENTER THE ROOM.</h2>
      <h2 className="font-serif text-4xl sm:text-6xl font-light text-fuchsia mb-6 tracking-tight">CHANGE YOUR CHAPTER.</h2>
      <p className="text-cream/70 uppercase tracking-[0.25em] text-sm mb-10">Good books · Dope women · Real conversations</p>
      <Link to="/join" className="btn-primary" data-testid="cta-join-room">Join The Room</Link>
      <p className="font-script text-2xl text-gold mt-6">Free to Join</p>
    </Reveal>
  </section>
);

export default EmailCaptureCTA;
